/**
 * A report on the thermal roll.
 *
 * The same 80mm receipt the till prints a bill on, turned to the day's summary
 * an owner pulls off the printer — the shift-close report's shape, for a chosen
 * day rather than a shift: a title, what it covers, then sections of label and
 * figure. Marked `.bill`, so the shared print rule makes it, and only it, the
 * thing that reaches the paper. On screen it shows as a preview of exactly that.
 */

export function ReportReceipt({ title, subtitle, meta = [], sections = [] }) {
  return (
    <div className="bill mx-auto max-w-[302px] bg-white p-3 font-mono text-[11px] leading-snug text-black">
      <header className="text-center">
        <h1 className="text-sm font-bold uppercase tracking-wide">{title}</h1>
        {subtitle && <p className="text-[11px]">{subtitle}</p>}
        {meta.map((line, i) => (
          <p key={i} className="text-[10px]">
            {line}
          </p>
        ))}
      </header>

      {sections
        .filter((s) => s && (s.rows ?? []).length > 0)
        .map((section, si) => (
          <div key={si}>
            <Rule />
            {section.heading && (
              <p className="mb-0.5 text-[10px] uppercase tracking-wide">{section.heading}</p>
            )}
            <dl className="space-y-0.5">
              {section.rows.map((row, ri) => (
                <div
                  key={ri}
                  className={`flex justify-between gap-2 ${row.strong ? 'text-[13px] font-bold' : ''}`}
                >
                  <dt className="min-w-0 break-words">{row.label}</dt>
                  <dd className="shrink-0 tabular-nums">{row.value}</dd>
                </div>
              ))}
            </dl>
          </div>
        ))}

      <Rule />

      <footer className="text-center text-[10px]">
        <p>
          Printed{' '}
          {new Date().toLocaleString('en-GB', {
            day: 'numeric',
            month: 'short',
            year: 'numeric',
            hour: '2-digit',
            minute: '2-digit',
          })}
        </p>
      </footer>
    </div>
  );
}

/** A dotted rule — what a thermal printer renders cleanly. */
function Rule() {
  return <div aria-hidden="true" className="my-1.5 border-t border-dashed border-black" />;
}
